// extracted by mini-css-extract-plugin
export default {"ClickableButton":"ClickableButton_ClickableButton__vYnN-"};